import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SliderModel } from '../Model/slider.model';
import { SharedApiService } from '../../../shared/service/util.service';

@Injectable({
  providedIn: 'root'
})
export class SliderService {

  private endpoint = `Slider/GetAll`

  private sharedApiService = inject(SharedApiService)

  getAll(): Observable<{ value: SliderModel[] }> {
    return this.sharedApiService.getAll(this.endpoint);
  }
}
